import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
import { palette } from 'util/style-helpers';
import { style } from './style';

interface Props {
  size?: number;
  strokeWidth?: number;
  fill?: string;
  position?: 'center' | 'fullscreen' | 'inline';
}
export const LoadingSpinner: FC<Props> = ({ size = 65, strokeWidth = 3, fill = palette.grey, position = 'center' }) => {
  const styles = style({
    duration: '1.4s',
    offset: 187,
    color: fill,
    position,
  });

  return (
    <div className={css(styles.container)}>
      <svg
        className={css(styles.spinner)}
        width={`${size}px`}
        height={`${size}px`}
        viewBox={`0 0 66 66`}
        xmlns='http://www.w3.org/2000/svg'>
        <circle
          className={css(styles.path)}
          fill='none'
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          cx='33'
          cy='33'
          r='30'
        />
      </svg>
    </div>
  );
};
